var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLayoutH1 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 36,
  viewBox: "0 0 48 36",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M44 0a4 4 0 0 1 4 4v28a4 4 0 0 1-4 4H4a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4zm0 4H4v28h40zm-8 17v2h-8v-2zm-23.717-8v.87l-1.148.128v3.51h4.57v-3.516l-1.14-.123V13h4.255v.87l-1.154.128v8.017l1.223.244V23h-4.4v-.74l1.217-.239v-3.483h-4.57v3.477l1.215.238V23H8.014v-.747l1.154-.245v-8.003L8 13.869V13zm10.964 1.848.71.11-.027 7.05 1.715.22V23h-5.479v-.773l1.872-.225v-5.19c-.499.077-1.277.18-1.879.27l-.198-.869c.861-.225 2.951-1.114 3.286-1.365M40 17v2H28v-2zm-4-4v2h-8v-2z"
})));
export default SvgLayoutH1;